export const loggedInPatientData = {
  data: {
    user_detail: {
      id: 284,
      firstName: 'Test Name',
      lastName: 'Test LastName',
      gender: 1,
      birthDate: '1947-07-19',
      city: null,
      userId: 1,
      addressLine1: null,
      addressLine2: null,
      mobilePhone: null,
      homePhone: null,
      extension: null,
      termId: 1,
      accountInfoStatus: 1,
      createdAt: '2020-04-21T14:59:27.228Z',
      updatedAt: '2021-03-02T19:47:26.361Z',
      createdBy: null,
      updatedBy: 173,
      countryId: null,
      stateId: null,
      zipCodeId: null,
      fullName: 'Test Name Test LastName',
    },
    user_roles: [
      {
        id: 152,
        userId: 1,
        roleId: 4,
        createdAt: '2020-04-21T14:59:35.241Z',
        updatedAt: '2020-04-21T14:59:35.241Z',
        createdBy: null,
        updatedBy: null,
        role: {
          id: 4,
          name: 'Patient',
          slug: 'patient',
          description: 'patient',
          parentId: null,
          group: 'Patient',
          createdAt: '2020-02-28T11:38:51.180Z',
          updatedAt: '2020-02-28T11:38:51.180Z',
          createdBy: null,
          updatedBy: null,
          role_actions: [],
        },
        name: 'Patient',
        userRoleId: 152,
        group: 'Patient',
        slug: 'patient',
      },
    ],
    id: 1,
    email: 'test.test@patient.com',
    newEmail: 'test1@patient.com',
    isVerifiedNewEmail: false,
    isSelfEnrolled: true,
    oldActivatedEmail: 'test@patient.com',
    isVerified: true,
    verifiedDate: '2020-04-21T15:00:55.219Z',
    verifyToken: '8d9d871a2796c7ffd9bd2995d75a6b',
    verifyExpires: '2021-02-26T20:13:03.133Z',
    resetToken: '$2b$11$IaAHeV1m6I3WYziMlYotEulclbhEjpyRNyzoj5A/5awz56UNqamWO',
    resetExpires: '2020-11-03T14:10:35.373Z',
    lastIpAddress: '::1',
    currentIpAddress: '::1',
    timezone: 'Asia/Yerevan',
    accountsExpired: false,
    isWorkFactorChanged: true,
    accountLocked: false,
    credentialsExpired: false,
    accountEnabled: true,
    type: 'patient',
    isUserReminded: 'never-reminded',
    loginAttempts: 0,
    deduUserId: 191087,
    bmiqUserId: null,
    migratedAt: null,
    migrateMessageShowed: false,
    isSubscribed: true,
    accountAccessToken: '982a1209ee051262f50182bd2931db',
    twoFaAccessToken: null,
    authSecret: null,
    authEnabled: false,
    authType: null,
    allowedFeatures: [],
    isTestUser: false,
    createdAt: '2020-04-21T14:59:27.193Z',
    updatedAt: '2021-03-09T14:31:05.950Z',
    createdBy: null,
    updatedBy: 173,
    fullName: 'Test Name Test LastName',
    associations: {
      Patient: {
        organizations: [
          {
            id: 1,
            name: 'Test Medical Center',
            active: true,
            siteId: 1027,
            address: null,
            city: null,
            subdomain: null,
            useReverseProxy: false,
            allowSelfEnrollment: true,
            timezone: null,
            authEnabled: false,
            defaultAppointmentTypeId: 70,
            defaultProviderId: 92,
            createdAt: '2020-04-30T15:07:17.624Z',
            updatedAt: '2020-12-15T09:36:24.205Z',
            createdBy: null,
            updatedBy: 1,
            ownerId: 199,
            countryId: null,
            stateId: null,
            zipCodeId: null,
            'organizations_patients.patientId': 10,
            'organizations_patients.organizationId': 8,
            'organization_ehr_platforms.id': null,
            'organization_ehr_platforms.ehrPlatformId': null,
          },
        ],
        providers: [
          {
            id: 41,
            email: 'provider@test.com',
            timezone: null,
            firstName: 'Alice',
          },
        ],
        patient: {
          id: 1,
          wellnessVision: '',
          enrollmentDate: '2020-04-21T14:59:27.233Z',
          lastContact: '2021-03-09T10:31:05.960Z',
          createdAt: '2020-04-21T14:59:27.233Z',
          updatedAt: '2021-03-09T14:31:05.960Z',
          userId: 1,
          createdBy: null,
          updatedBy: 173,
          patientAvailabilityId: null,
          programId: 1,
          patientGoalId: null,
        },
      },
    },
  },
  OTToken: '46472562',
};
export const loggedInOrgAdminData = {
  data: {
    user_detail: {
      id: 237,
      firstName: 'Ann',
      lastName: 'Noctis',
      gender: null,
      birthDate: null,
      city: null,
      userId: 138,
      addressLine1: null,
      addressLine2: null,
      mobilePhone: null,
      homePhone: null,
      extension: null,
      termId: 1,
      accountInfoStatus: 1,
      createdAt: '2020-03-06T09:14:52.523Z',
      updatedAt: '2021-06-28T09:15:21.457Z',
      createdBy: null,
      updatedBy: 138,
      countryId: null,
      stateId: null,
      zipCodeId: null,
      fullName: 'Ann Noctis',
    },
    user_roles: [
      {
        id: 123,
        userId: 138,
        roleId: 3,
        createdAt: '2020-03-06T09:14:52.544Z',
        updatedAt: '2020-03-06T09:14:52.544Z',
        createdBy: null,
        updatedBy: null,
        role: {
          id: 3,
          name: 'Organization Admin',
          slug: 'organization_admin',
          description: 'Organization Admin with full access to the associated organization',
          parentId: null,
          group: 'Organization',
          createdAt: '2020-02-28T11:38:51.174Z',
          updatedAt: '2020-02-28T11:38:51.174Z',
          createdBy: null,
          updatedBy: null,
          role_actions: [],
        },
        name: 'Organization Admin',
        userRoleId: 123,
        group: 'Organization',
        slug: 'organization_admin',
      },
    ],
    id: 138,
    email: 'ann+00@tidepoollabs.com',
    newEmail: null,
    isVerifiedNewEmail: true,
    oldActivatedEmail: 'ann+001@tidepoollabs.com',
    isVerified: true,
    verifiedDate: '2021-04-19T13:26:38.766Z',
    verifyToken: null,
    verifyExpires: null,
    resetToken: null,
    resetExpires: null,
    lastIpAddress: '45.146.36.227',
    currentIpAddress: '45.146.36.227',
    timezone: 'Asia/Yerevan',
    accountsExpired: false,
    isWorkFactorChanged: true,
    accountLocked: false,
    credentialsExpired: false,
    accountEnabled: true,
    type: 'organization-admin',
    isUserReminded: 'reminded-7',
    loginAttempts: 0,
    userIdentifier: '695ea1bba8293ddca8f5f0eadb1b5410309496be_1604406803613@intellihealth.com',
    deduUserId: 362811,
    bmiqUserId: null,
    migratedAt: null,
    migrateMessageShowed: false,
    isSubscribed: true,
    accountAccessToken: 'd8cbd3bbe4a778e49a6a01d77fa6ca',
    twoFaWaiting: false,
    authSecret: {
      key: 'BYOUOPCYL5JTQAKZ',
      verified: true,
    },
    authEnabled: false,
    authType: null,
    backupCodes: false,
    allowedFeatures: null,
    isTestUser: false,
    isSmsNotificationsEnabled: false,
    isMobileVerified: false,
    passwordLastUpdate: '2021-06-25T03:07:40.742Z',
    createdAt: '2020-03-06T09:14:52.500Z',
    updatedAt: '2021-08-24T11:24:56.091Z',
    createdBy: null,
    updatedBy: 138,
    fullName: 'Ann Noctis',
    associations: {
      Organization: {
        organizations: [
          {
            id: 8,
            name: 'Test Medical Center',
            active: true,
            siteId: null,
            address: 'test address',
            city: null,
            subdomain: null,
            useReverseProxy: false,
            timezone: 'America/Los_Angeles',
            authEnabled: false,
            passwordExpiresAfter: null,
            createdAt: '2020-03-06T09:14:52.528Z',
            updatedAt: '2021-07-16T10:54:06.569Z',
            createdBy: null,
            updatedBy: 804,
            ownerId: 138,
            countryId: 1,
            stateId: 7,
            zipCodeId: 13145,
            'organizations_users.organizationId': 8,
            'organizations_users.userId': 138,
          },
        ],
        patient: null,
      },
    },
    passExpNotification: 'notExpire',
  },
  OTToken: '46472562',
};
export const loggedInIHAdminData = {
  data: {
    user_detail: {
      id: 1,
      firstName: 'IH',
      lastName: 'Admin',
      gender: null,
      birthDate: null,
      city: null,
      userId: 1,
      addressLine1: null,
      addressLine2: null,
      mobilePhone: null,
      homePhone: null,
      extension: null,
      termId: 1,
      accountInfoStatus: 1,
      createdAt: '2019-09-09T20:47:21.407Z',
      updatedAt: '2021-08-09T15:35:22.941Z',
      createdBy: null,
      updatedBy: null,
      countryId: null,
      stateId: null,
      zipCodeId: null,
      fullName: 'IH Admin',
    },
    user_roles: [
      {
        id: 25,
        userId: 1,
        roleId: 1,
        createdAt: '2020-02-28T11:38:52.166Z',
        updatedAt: '2020-02-28T11:38:52.166Z',
        createdBy: null,
        updatedBy: null,
        role: {
          id: 1,
          name: 'IH Admin',
          slug: 'ih_admin',
          description: 'Super user',
          parentId: null,
          group: 'Admin',
          createdAt: '2020-02-28T11:38:50.340Z',
          updatedAt: '2020-02-28T11:38:50.340Z',
          createdBy: null,
          updatedBy: null,
          role_actions: [],
        },
        name: 'IH Admin',
        userRoleId: 25,
        group: 'Admin',
        slug: 'ih_admin',
      },
    ],
    id: 1,
    email: 'example@bmiq.com',
    newEmail: null,
    isVerifiedNewEmail: false,
    oldActivatedEmail: null,
    isVerified: true,
    verifiedDate: '2019-09-09T20:47:17.512Z',
    verifyToken: 'f947843702740e0274467d092f859b',
    verifyExpires: '2019-09-14T20:47:07.384Z',
    resetToken: null,
    resetExpires: null,
    lastIpAddress: '45.146.36.227',
    currentIpAddress: '45.146.36.227',
    timezone: 'Asia/Yerevan',
    accountsExpired: false,
    isWorkFactorChanged: true,
    accountLocked: false,
    credentialsExpired: false,
    accountEnabled: true,
    type: 'admin',
    isUserReminded: 'never-reminded',
    loginAttempts: 0,
    userIdentifier: 'lusinekarapetian@tidepoollabs.com',
    deduUserId: 163168,
    bmiqUserId: null,
    migratedAt: null,
    migrateMessageShowed: false,
    isSubscribed: true,
    accountAccessToken: 'de7aa01374e880adcafdb6364b5ede',
    twoFaWaiting: false,
    authSecret: {
      secret: '157368',
      expired: '2021-05-14T11:49:45.804Z',
    },
    authEnabled: false,
    authType: null,
    backupCodes: false,
    allowedFeatures: null,
    isTestUser: false,
    isSmsNotificationsEnabled: false,
    isMobileVerified: false,
    passwordLastUpdate: null,
    createdAt: '2019-09-09T20:47:17.512Z',
    updatedAt: '2021-08-24T11:17:34.392Z',
    createdBy: null,
    updatedBy: 337,
    fullName: 'IH Admin',
    associations: {
      Admin: {
        organizations: [],
        patient: null,
      },
    },
    passExpNotification: 'notExpire',
  },
  OTToken: '46472562',
};
export const loggedInProviderData = (multipleOrganizations = false) => ({
  data: {
    user_detail: {
      id: 457,
      firstName: 'Alice',
      lastName: 'in Chains',
      gender: null,
      birthDate: null,
      city: null,
      userId: 248,
      addressLine1: null,
      addressLine2: null,
      mobilePhone: null,
      homePhone: null,
      extension: null,
      termId: 1,
      accountInfoStatus: 1,
      createdAt: '2020-07-06T09:12:48.232Z',
      updatedAt: '2021-08-04T10:02:53.110Z',
      createdBy: null,
      updatedBy: 248,
      countryId: null,
      stateId: 2,
      zipCodeId: 36317,
      fullName: 'Alice in Chains',
    },
    user_roles: [
      {
        id: 218,
        userId: 248,
        roleId: 11,
        createdAt: '2020-07-06T09:12:48.262Z',
        updatedAt: '2021-08-04T10:02:53.138Z',
        createdBy: null,
        updatedBy: 248,
        role: {
          id: 11,
          name: 'Dietitian',
          slug: 'provider_rd_admin',
          description: null,
          parentId: null,
          group: 'Provider',
          createdAt: '2020-02-28T11:38:51.194Z',
          updatedAt: '2020-02-28T11:38:51.194Z',
          createdBy: null,
          updatedBy: null,
          role_actions: [],
        },
        name: 'Dietitian',
        userRoleId: 218,
        group: 'Provider',
        slug: 'provider_rd_admin',
      },
    ],
    id: 248,
    email: 'ann+16@tidepoollabs.com',
    newEmail: 'ann+016@tidepoollabs.com',
    isVerifiedNewEmail: false,
    oldActivatedEmail: 'paruyr2002@bk.ru',
    isVerified: true,
    verifiedDate: '2020-07-06T09:20:56.235Z',
    verifyToken: '95f071d6a2a871116aa0df3e55f865',
    verifyExpires: '2021-08-10T21:57:36.533Z',
    resetToken: null,
    resetExpires: null,
    lastIpAddress: '45.146.36.227',
    currentIpAddress: '45.146.36.227',
    timezone: 'Asia/Yerevan',
    accountsExpired: false,
    isWorkFactorChanged: true,
    accountLocked: false,
    credentialsExpired: false,
    accountEnabled: true,
    type: 'provider-admin',
    isUserReminded: 'never-reminded',
    loginAttempts: 0,
    userIdentifier: 'dc0a8da754063b43383cc4d679ac93fca89ba3ea_1594027256262@intellihealth.com',
    deduUserId: 195117,
    bmiqUserId: null,
    migratedAt: null,
    migrateMessageShowed: false,
    isSubscribed: true,
    accountAccessToken: '3ca813d8f9047fa667ea64b32c846e',
    twoFaWaiting: false,
    authSecret: {
      key: 'LFRFI2D7IEFVOXLB',
      verified: true,
    },
    authEnabled: false,
    authType: null,
    backupCodes: false,
    allowedFeatures: null,
    isTestUser: false,
    isSmsNotificationsEnabled: false,
    isMobileVerified: false,
    passwordLastUpdate: '2021-07-26T08:30:21.632Z',
    createdAt: '2020-07-06T09:12:48.222Z',
    updatedAt: '2021-08-24T09:55:05.970Z',
    createdBy: null,
    updatedBy: 248,
    fullName: 'Alice in Chains',
    associations: {
      Provider: {
        organizations: [
          {
            id: 8,
            name: 'Armenia Medical Center',
            active: true,
            siteId: null,
            address: 'test3',
            city: null,
            subdomain: null,
            useReverseProxy: false,
            timezone: 'America/Los_Angeles',
            authEnabled: false,
            passwordExpiresAfter: null,
            createdAt: '2020-03-06T09:14:52.528Z',
            updatedAt: '2021-07-16T10:54:06.569Z',
            createdBy: null,
            updatedBy: 804,
            ownerId: 138,
            countryId: 1,
            stateId: 7,
            zipCodeId: 13145,
            'organization_providers.providerId': 41,
            'organization_providers.provider.providers_users.id': 41,
          },
          ...(multipleOrganizations
            ? [
                {
                  id: 11,
                  name: 'Arevik Medical Center',
                  active: true,
                  siteId: 1027,
                  address: null,
                  city: 'Los Angeles',
                  subdomain: null,
                  useReverseProxy: false,
                  timezone: 'America/Anchorage',
                  authEnabled: false,
                  passwordExpiresAfter: null,
                  createdAt: '2020-04-30T15:07:17.624Z',
                  updatedAt: '2021-07-29T08:51:00.049Z',
                  createdBy: null,
                  updatedBy: 430,
                  ownerId: 199,
                  countryId: 1,
                  stateId: 2,
                  zipCodeId: 36810,
                  'organization_providers.providerId': 41,
                  'organization_providers.provider.providers_users.id': 41,
                },
                {
                  id: 31,
                  name: 'Avanta',
                  active: true,
                  siteId: 1343,
                  address: null,
                  city: null,
                  subdomain: null,
                  useReverseProxy: false,
                  timezone: 'America/New_York',
                  authEnabled: false,
                  passwordExpiresAfter: null,
                  createdAt: '2021-03-26T12:10:05.125Z',
                  updatedAt: '2021-05-07T15:00:46.152Z',
                  createdBy: 1,
                  updatedBy: 1,
                  ownerId: 1238,
                  countryId: 1,
                  stateId: 2,
                  zipCodeId: null,
                  'organization_providers.providerId': 41,
                  'organization_providers.provider.providers_users.id': 41,
                },
              ]
            : []),
        ],
        providers: [
          {
            id: 41,
            email: 'ann+16@tidepoollabs.com',
            timezone: 'Asia/Yerevan',
            firstName: 'Alice',
            lastName: 'in Chains',
          },
        ],
        patient: null,
      },
    },
    passExpNotification: 'notExpire',
  },
  OTToken: '46472562',
});
export const createPass = {
  action: 'create',
  email: 'test@email.com',
};
export const changeEmail = {
  action: 'changeEmail',
  email: 'test1@email.com',
};

export const createPassToken = 'a6b32a49a272d96a4e445e1ccf45fd';
export const selfRegistrationToken = 'a6b32a49a272d96a4e445e1ccf54df';
export const resetToken = '?resetToken=2116___6372a51bfd8c7bd185f4280d688c08';

export const changeEmailToken = 'c3edef2c465ba3b20538da5fa6b8a2';
export const resendInvitationToken = 'b3d4221dc2556a5101480e41777bab';

export const codeSuccess = '123456';
export const codeError = '654321';

export const backupCodes = ['06025524', '44852312', '23152343', '70256781', '60941757', '59501609', '09259845', '61326874', '21050307', '05215498'];
